module.exports = __webpack_public_path__ + "/assets/img/icon_eyee3a7e55f.svg";